/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import CN from 'classnames';
import { Button, Input } from 'components/atoms';
import { Loader } from 'components/atoms/Loader';
import { useGetAllCreators } from 'framework/api/methods';
// import { ComplexDateRangePicker } from 'components/atoms/ComplexDateRangePicker';
import React, { FC, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useDebounce from 'utils/debounce';

export interface ContentCreatorsProps {
  [x: string]: any;
}

export const ContentCreators: FC<ContentCreatorsProps> = () => {
  const navigate = useNavigate();

  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const [searchText, setSearchText] = useState('');
  const [creatorsList, setCreatorsList] = useState([]);

  const { mutate: getAllCreatorsMutate, isLoading } = useGetAllCreators();

  const getAllCreators = () => {
    getAllCreatorsMutate(
      {
        search: searchText === '' ? 'All' : searchText,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          setCreatorsList(successData?.creators || []);
        },
        onError: ({ response: { data: errData }, response }: any) => {
          setCreatorsList([]);
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            // notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  const debouncedSearchText = useDebounce(searchText, 500);

  useEffect(() => {
    getAllCreators();
  }, [debouncedSearchText]);

  const formatDate = (isoString: string) => {
    const date = new Date(isoString);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  };

  const convertToLocalNumber = (phoneNumber: string) => {
    const str = String(phoneNumber);
    if (str.startsWith('94')) {
      return `0${str.slice(2)}`;
    }
    return str;
  };

  const formatDateDob = (dateString: string) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  return (
    <div className="flex flex-col w-full h-full py-6 px-8">
      <div className="flex justify-between items-center">
        {/* <div className="w-1/3">
          <div className="flex justify-end items-end gap-x-2">
            <div className="w-fit">
              <Input
                value="30 Jan 25 - 25 Jan 25"
                icon="ri-calendar-line !text-[#0F3659] !text-sm"
                onclick={() => {
                  setIsOpenDatePicker(!isOpenDatePicker);
                }}
                inputClassName="border border-[#C3D3E2] !text-sm !rounded-lg w-[220px] !h-[37.6px] !text-[#0F3659] cursor-pointer"
                onChange={() => {
                  //
                }}
              />

              <div
                className={CN(
                  'fixed h-full bg-black bg-opacity-40 flex justify-center items-center z-50 shadow-lg top-0 bottom-0 right-0 left-0',
                  {
                    hidden: !isOpenDatePicker,
                  },
                )}
              >
                <div className="bg-white  border border-neutral-200" ref={pickerRef}>
                  <ComplexDateRangePicker
                    isResponsive
                    isEnableClearButton={false}
                    selectedDate={[new Date(), new Date()]}
                    onChange={() => {
                      //
                    }}
                    onClose={() => {
                      setIsOpenDatePicker(false);
                    }}
                    showDateDisplay={false}
                    isStaticRanges
                    isRangesDisable
                  />
                </div>
              </div>
            </div>

            <Button appearance="secondary">
              <i className="ri-upload-2-line pr-2" />
              Export
            </Button>
          </div>
        </div> */}

        <div className="w-1/3 flex justify-start items-start">
          <div className="w-full">
            <Input
              icon="ri-search-line !text-[#C40D42] font-semibold"
              value={searchText}
              placeholder="Search here..."
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
            />
          </div>
        </div>
      </div>

      {isLoading && <Loader appearance="black" className="mt-5" />}

      {!isLoading && creatorsList?.length === 0 && (
        <div className="mt-5 text-sm text-center w-full text-neutral-500">
          No content creators found.
        </div>
      )}
      <div className="h-auto overflow-y-auto w-full mt-5 grid lg:grid-cols-4 grid-cols-2 gap-4  items-stretch">
        {!isLoading &&
          creatorsList?.map((creator: any, index) => (
            <div
              className="bg-[#EFEFEF] h-full w-full flex flex-col justify-start rounded-[10px] py-5 px-3 cursor-pointer border-2 border-[#bfc2c3]"
              onClick={() => {
                navigate(`/content-creators/${creator.phone_number}`, {
                  state: { creatorName: creator.username },
                });
              }}
            >
              <div className="text-xl font-semibold text-[#63717A] text-center">
                {creator.username || `-`}
              </div>
              <div className="text-sm text-[#63717A] text-center">
                {formatDate(creator.created_at)}
              </div>

              <div className="bg-white rounded-[10px] p-4 w-full flex flex-col mt-5 text-xs text-[#63717A]">
                <div className="text-sm font-semibold text-[#63717A] text-center capitalize pb-1">
                  {creator.first_name || `-`}
                  {` ${(creator.last_name && creator.last_name) || `-`}`}
                </div>
                <div className="flex justify-start items-center gap-x-2">
                  <i className="ri-map-pin-fill text-[#C40D42] text-base" />
                  <div className="text-left">
                    {[creator.address1, creator.address2, creator.address3]
                      .filter(Boolean)
                      .join(', ') || `-`}
                  </div>
                </div>

                <div className="flex justify-between items-center mt-3 flex-wrap">
                  <div className="flex gap-x-1">
                    <i className="ri-phone-fill text-[#C40D42] text-base leading-none" />
                    <div>
                      {creator.phone_number ? convertToLocalNumber(creator.phone_number) : '-'}
                    </div>
                  </div>

                  <div className="flex gap-x-1">
                    <i className="ri-cake-fill text-[#C40D42] text-base leading-none" />
                    <div>{creator.dob ? formatDateDob(creator.dob) : `-`}</div>
                  </div>
                </div>
                <div className="flex gap-x-1 mt-3">
                  <i className="ri-mail-fill text-[#C40D42] text-base leading-none" />
                  <div className=" line-clamp-1 break-all">{creator.email || `-`}</div>
                </div>
              </div>

              <div className="bg-white rounded-[10px] p-4 w-full flex flex-col text-xs text-[#63717A] mt-3 gap-y-2">
                <div className="flex gap-x-1">
                  <div className="font-medium">Acc Holder :-</div>
                  <div>{creator.account_holder_name || `-`}</div>
                </div>
                <div className="flex gap-x-1">
                  <div className="font-medium">Acc No :- </div>
                  <div>{creator.account_number || `-`}</div>
                </div>
                <div className="flex gap-x-1">
                  <div className="font-medium">Bank :- </div>
                  <div>{creator.bank_name || `-`}</div>
                </div>
                <div className="flex gap-x-1">
                  <div className="font-medium">Branch :- </div>
                  <div>{creator.branch_name || `-`}</div>
                </div>
              </div>

              {/* <div className="flex w-full items-center justify-center">
                <Button
                  isRounded
                  className="mt-3"
                  onClick={() => {
                    navigate(`/content-creators/${creator.phone_number}`);
                  }}
                >
                  MORE
                </Button>
              </div> */}
            </div>
          ))}
      </div>
    </div>
  );
};

export default ContentCreators;
